import { render, staticRenderFns } from "./NewsPublishPage.vue?vue&type=template&id=5fa29d00&scoped=true"
import script from "./NewsPublishPage.vue?vue&type=script&lang=js"
export * from "./NewsPublishPage.vue?vue&type=script&lang=js"
import style0 from "./NewsPublishPage.vue?vue&type=style&index=0&id=5fa29d00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa29d00",
  null
  
)

export default component.exports